import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'

const ASSIGN_PROFILE_REVIEW = gql`
  mutation assignProfileReview($input: AssignProfileReview!) {
    assignProfileReview(input: $input) {
      id
      profileOwnerId
      profileReviewerId
    }
}
`

export default () => useMutation(ASSIGN_PROFILE_REVIEW)
